import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import es from './locales/es';
import en from './locales/en';
import pt from './locales/pt';

export const LANGUAGES = [
  { code: 'es', label: 'Espanol', flag: 'ES' },
  { code: 'en', label: 'English', flag: 'GB' },
  { code: 'pt', label: 'Portugues', flag: 'PT' },
] as const;

export type LanguageCode = typeof LANGUAGES[number]['code'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: { translation: es },
      en: { translation: en },
      pt: { translation: pt },
    },
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'worsaas-lang',
      caches: ['localStorage'],
    },
  });

export default i18n;
